import { IUserDetails } from './user-details.model';
import { UserTypes, UserTypesIcon } from '../../common/enums';

export class UserCompactInfo {
  /**
   *
   */
  firstname: string;
  lastname: string;
  id: number;
  type: string;

  get icon(): string {
    switch (this.type) {
      case UserTypes.SuperAdmin:
        return 'stars'
      // case UserTypes.ManagerAdmin:
      case UserTypes.Manager:
      case UserTypes.SalesPerson:
        return UserTypesIcon.ManagerIcon;
      case UserTypes.MaintenanceReferent:
      case UserTypes.VehicleReferent:
        return UserTypesIcon.ManagerBasicIcon
      // case UserTypes.caretaker2:
      case UserTypes.Caretaker:
      case UserTypes.IndependentContractor:
      case UserTypes.InternalContractor:
      case UserTypes.ExternalProvider:
      case UserTypes.ExternalProviderMember:
        return UserTypesIcon.IndependentContractorIcon;
      case UserTypes.Owner:
      case UserTypes.PlusUser:
        return UserTypesIcon.OwnerIcon;
      case UserTypes.Tenant:
      case UserTypes.Customer:
      case UserTypes.SimpleUser:
        return UserTypesIcon.TenantIcon;
      default:
        return UserTypesIcon.TenantIcon;
    }
  }
  get typeOfEntity(): string {
    return this.type === UserTypes.IndependentContractor
      ? 'intervenant'
      : 'entreprise'
  }
  get fullName(): string {
    return `${this.firstname} ${this.lastname}`;
  }
  constructor(opt?: IUserDetails) {
    this.id = opt.id;
    this.firstname = opt.firstname;
    this.lastname = opt.lastname;
    this.type = opt.type;
  }
}



// WEBPACK FOOTER //
// ./src/models/user/user-compact-info.model.ts